window.alpineRender = (instance) => {
    instance.$el
        .querySelectorAll(":scope > script[x-json]")
        .forEach((script) => {
            const property = script.getAttribute("x-json");
            instance[property] = JSON.parse(script.innerText);
            script.remove();
        });

    instance.$el.querySelectorAll("[x-del]").forEach((element) => {
        element.remove();
    });
};
